import { useEffect } from 'react';

export function useTitle(title) {
    useEffect(() => {
        document.title = window.tvConfig.title + (title ? ' - ' + title : '');
    }, [title]);
}
